module.exports = __webpack_public_path__ + "img/logotops.bef7163a.png";